import {isNil} from "lodash";
import {Colors} from "../../../../ui";

type AccountStatus = "notReported" | "inRiskOfBeingReported" | "alreadyReported";

const notificationColorMap = {
  notReported: undefined,
  inRiskOfBeingReported: Colors.orange._700,
  alreadyReported: Colors.red._800,
};

const getUntilCreditReportTitle = (daysUntilCreditReport?: number) => {
  if (isNil(daysUntilCreditReport) || daysUntilCreditReport < 0) {
    return null;
  }
  if (daysUntilCreditReport > 1) {
    return `Credit report listing in ${daysUntilCreditReport} days`;
  }
  if (daysUntilCreditReport === 1) {
    return "Credit report listing in 1 day";
  }
  return "Credit report listing today";
};

const getDataSectionDetail = (accountStatus: AccountStatus, daysUntilCreditReport?: number) => {
  const detailsMap = {
    notReported: undefined,
    inRiskOfBeingReported: {
      background: Colors.orange._100,
      title: getUntilCreditReportTitle(daysUntilCreditReport),
      content: "Resolve this debt to prevent a collections listing on your credit report.",
    },
    alreadyReported: {
      background: Colors.red._100,
      title: "A negative entry was made on your\ncredit report",
      content:
        "Once your payment plan is completed and account is resolved, we will notify the credit bureaus to remove the\n" +
        "listing of this debt that Bounce AI, Inc has reported.",
    },
  };
  return detailsMap[accountStatus];
};

export {getDataSectionDetail, notificationColorMap};
export type {AccountStatus};
